const listChecklistItem = {
  primary: 'Sección sin Preguntas'
};

export default listChecklistItem;
